@if (this.isResourceNotFound()) {
  <app-guest-resource-not-found></app-guest-resource-not-found>
} @else {
  <app-guest-container [isShowLanguageSelector]="!isLoading()">
    <div class="title">
      <h1 i18n="@@sharing.accessshareddata">Access shared data</h1>
    </div>

    @if (isLoading()) {
      <app-loader containerClass="no-margin"></app-loader>
    } @else {
      <div class="subtitle">
        <ng-container i18n="@@sharing.verificationcodesent">
          We have sent you a verification code to
        </ng-container>
        &nbsp;
        <b>{{ recipient }}</b>
        <span>.&nbsp;</span>
        <ng-container i18n="@@sharing.help">Please, enter it below:</ng-container>
      </div>

      <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="flex-column">
        <app-input
          type="text"
          formControlName="verificationCode"
          [label]="translations.verificationCodeLabel"
          autofocus
        ></app-input>

        <div
          class="details"
          [ngClass]="{
            'less-margin':
              formGroup.controls['verificationCode'].touched &&
              formGroup.controls['verificationCode'].invalid,
          }"
        >
          <a
            class="clickable underline"
            (click)="onSendVerificationCode()"
            (keydown.enter)="onSendVerificationCode()"
            tabindex="0"
            i18n="@@sharing.resendcode"
          >
            Re-send verification code
          </a>
        </div>

        <div class="mt-30">
          <app-button
            class="fresh-green"
            [disabled]="formGroup.invalid"
            accessibilityRole="submit"
            size="large"
            i18n="@@sharing.access"
          >
            Access
          </app-button>
        </div>
      </form>
    }
  </app-guest-container>
}
